import { useTranslation } from 'react-i18next';
import { Button, Dialog, Pressable } from '@fluent/ui';
import { EXAM_TASKS } from '@fluent/types';

/**
 * How the simulator differs from the real exam — Tornike 2026-09-25: the
 * page must say plainly that there is no essay and the time is not the
 * real 3 hours. Two surfaces: an always-visible notice at the top of the
 * ტესტი page, and this dialog (opened by the notice, by the ⓘ button, and
 * automatically on a learner's first visit).
 */

export function ExamNotice({ onMore }: { onMore: () => void }) {
  const { t } = useTranslation();
  return (
    <aside className="fluent-exam__notice" role="note">
      <span className="fluent-exam__notice-icon" aria-hidden="true">
        !
      </span>
      <div className="fluent-exam__notice-body">
        <p className="fluent-exam__notice-title">{t('exam.notice_title')}</p>
        <p>{t('exam.notice_body')}</p>
        <Pressable className="fluent-exam__notice-more" onClick={onMore}>
          {t('exam.notice_more')} →
        </Pressable>
      </div>
    </aside>
  );
}

export function ExamInfoDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('exam.info_title')}
      actions={
        <Button variant="primary" size="md" fullWidth onClick={() => onOpenChange(false)}>
          {t('exam.info_ok')}
        </Button>
      }
    >
      <div className="fluent-exam__info">
        <p>{t('exam.info_intro')}</p>
        <p className="fluent-exam__info-sub">{t('exam.info_tasks_title')}</p>
        <ol className="fluent-exam__info-tasks">
          {EXAM_TASKS.map((task, i) => (
            <li key={task.key}>
              <span>
                {i + 1}. {t(`exam.task_${i + 1}`)}
              </span>
              {/* Just the number: the line above already says "… 54 ქულა:", and
                  "12 ქულა" made two-column rows wrap on a phone. */}
              <span className="fluent-exam__info-pts" aria-label={t('exam.task_points', { n: task.items })}>
                {task.items}
              </span>
            </li>
          ))}
        </ol>
        <div className="fluent-exam__info-diff">
          <p className="fluent-exam__info-sub">{t('exam.info_diff_title')}</p>
          <ul>
            <li>{t('exam.info_diff_essay')}</li>
            <li>{t('exam.info_diff_time')}</li>
          </ul>
        </div>
        <p>{t('exam.info_timer')}</p>
        <p>{t('exam.info_listening')}</p>
      </div>
    </Dialog>
  );
}
